import {
  CRM,
  custom_API,
  ERP,
  fieldvisit,
  HRMS,
  maps,
  social,
  tools,
  utilia,
} from "../../helpers/constant/imageUrl";

export const SOLUTIONS = [
  {
    img: social,
    text: "social listening",
    path: "/solutions/social_listening",
  },
  {
    img: utilia,
    text: "utilia",
    path: "/solutions/utilia",
  },
  {
    img: fieldvisit,
    text: "field visit",
    path: "/solutions/field_visit",
  },
  {
    img: "/images/hrms.svg",
    text: "HRMS",
    path: "/hrms",
  },
];

export const DIRECT_CARDS = [
  {
    img: "/images/pcard1.webp",
    alt: "Social media engagement brand growth",
    title: "Harness the Power of Social Media to Elevate Customer Engagement and Brand Growth",
    path: "/solutions/social_listening",
  },
  {
    img: "/images/pcard2.webp",
    alt: "LinkedIn extension CRM scraping",
    title: "Your Ultimate LinkedIn Chrome Extension and Data Scraping Tool for CRM Integration",
    path: "/solutions/utilia",
  },{
    img: "/images/pcard3.webp",
    alt: "Field teams Salesforce solution",
    title: "Empower Your Field Teams with a Custom Salesforce - Powered Solution",
    path: "/solutions/field_visit",
  },{
    img: "/images/pcard4.webp",
    alt: "Social listening solution",
    title: "Our Social Listening Solution",
    path: "/solutions/social_listening",
  },{
    img: "/images/pcard5.webp",
    alt: "Utilia LinkedIn Chrome extension",
    title: "Utilia - Advanced LinkedIn Chrome Extension",
    path: "/solutions/utilia",
  },{
    img: "/images/pcard6.webp",
    alt: "Field operations smart solutions",
    title: "Revolutionize Field Operations with Smart Solutions",
    path: "/solutions/field_visit",
  },{
    img: "/images/pcard7.webp",
    alt: "Social media case creation",
    title: "Automate Customer Interaction Management with Social Media Case Creation",
    path: "/solutions/social_listening",
  },{
    img: "/images/pcard8.webp",
    alt: "Utilia applications",
    title: "Real-World Applications of Utilia",
    path: "/solutions/field_visit",
  },
]

export const INDUSTRY_FIELD_VISITS = [
  {
    text: "Manufacturing",
    content: {
      img: "/images/manufacture.webp",
      title: "Manufacturing Field Service Management",
      list: [
        "Simplify machinery inspections, conduct quality control audits, manage equipment installation and commissioning, and ensure compliance with safety standards during site visits.",
      ],
    },
  },
  {
    text: "Healthcare",
    content: {
      img: "/images/healthcare_SFV.webp",
      title: "Healthcare Field Operations",
      list: [
        "Manage home healthcare visits, patient follow-ups, medical equipment deliveries, and inventory audits for clinics and pharmacies to improve patient care and operational efficiency.",
      ],
    },
  },
  {
    text: "Pharmaceuticals",
    content: {
      img: "/images/pharma_SFV.webp",
      title: "Pharmaceutical Sales and Distribution",
      list: [
        "Optimize medical representative beats, conduct stockist inventory checks, streamline order collection, and ensure regulatory compliance during on-ground activities.",
      ],
    },
  },
  {
    text: "Real Estate",
    content: {
      img: "/images/estate_SFV.webp",
      title: "Real Estate Field Operations",
      list: [
        "Manage property showings, inspect construction progress, capture client feedback, and oversee post-sale project walkthroughs for seamless real estate operations.",
      ],
    },
  },
  {
    text: "FMCG",
    content: {
      img: "/images/FMCG_SFV.webp",
      title: "FMCG Field Sales Management",
      list: [
        "Conduct retail outlet inventory checks, ensure promotional compliance, verify product placements, and execute replenishment orders to streamline retail operations.",
      ],
    },
  },
  {
    text: "Automotive",
    content: {
      img: "/images/automotive_SFV.webp",
      title: "Automotive Dealer and Service Center Management",
      list: [
        "Oversee dealer visits, manage spare parts inventory, organize test drives, perform service center inspections, and track warranty compliance.",
      ],
    },
  },
  {
    text: "Education",
    content: {
      img: "/images/education_SFV.webp",
      title: "Education Field Outreach Programs",
      list: [
        "Conduct campus inspections, coordinate recruitment drives, plan corporate placement activities, and manage alumni networking efforts to enhance institutional operations.No matter your industry, our solution adapts to your specific use cases and operational needs.",
      ],
    },
  },
  {
    text: "Energy & Utilities",
    content: {
      img: "/images/energy_SFV.webp",
      title: "Energy and Utilities Field Services",
      list: [
        "Schedule site inspections, track compliance audits, manage equipment installations, and monitor renewable energy installations to ensure smooth utility operations.",
      ],
    },
  },
  {
    text: "Retail",
    content: {
      img: "/images/retail_SFV.webp",
      title: "Retail Store Operations Management",
      list: [
        "Audit stock levels, ensure proper promotional displays, collect real-time feedback, and coordinate product launches for efficient retail management.",
      ],
    },
  },
  {
    text: "Hospitality",
    content: {
      img: "/images/hospitality_SFV.webp",
      title: "Hospitality Property Management",
      list: [
        "Inspect hotel facilities, coordinate vendor supplies, track guest satisfaction, and ensure consistent service quality across multiple locations.",
      ],
    },
  },
];

export const FIELD_VISIT_INTEGRATIONS = [
  {
    img: CRM,
    title: "CRM Integration",
    desc: "Automate case assignments, track customer issues, and ensure timely resolution by syncing field activities with your Customer Relationship Management system.",
  },
  {
    img: HRMS,
    title: "HRMS Integration",
    desc: "Simplify attendance tracking by syncing agent activity with your Human Resource Management System, while automating travel and expense claim submissions.",
  },
  {
    img: maps,
    title: "Google Maps Integration",
    desc: "Enable real-time navigation and intelligent route optimization to reduce travel time and fuel costs, ensuring maximum efficiency for your field agents.",
  },
  {
    img: ERP,
    title: "ERP Integration",
    desc: "Sync inventory, order management, and other operational workflows with your Enterprise Resource Planning system for seamless back-office coordination.",
  },
  {
    img: tools,
    title: "Third-Party Tools",
    desc: "Connect with messaging apps, email platforms, and collaboration tools to enhance communication between field agents and office teams.",
  },
  {
    img: custom_API,
    title: "Custom API Integration",
    desc: "Leverage APIs to integrate this solution with industry-specific tools, ensuring compatibility with your unique operational workflows.",
  },
];

export const FIELD_VISIT = {
  features1: [
    {
      title: "Web and Mobile Application for Field Service Management: ",
      desc: "Access and manage tasks seamlessly from your desktop or smartphone, enabling productivity whether you're in the office or on the go.",
    },
    {
      title: "Automated Visit Scheduling & Task Assignment: ",
      desc: "Streamline planning by assigning field visits based on agent availability, location, and workload to maximize efficiency.",
    },
    {
      title: "Route Optimization Software: ",
      desc: "Empower field agents with the best possible travel routes, reducing fuel costs and travel time, powered by Google Maps integration.",
    },
  ],
  features2: [
    {
      title: "Real-Time Agent Tracking: ",
      desc: "Gain visibility into the live location of your field workforce, enhancing accountability and ensuring on-time service delivery.",
    },
    {
      title: "Smart Attendance and Leave Tracking: ",
      desc: "Automatically track agent activity within the app, flagging inactivity as potential leave, and sync seamlessly with HRMS for attendance validation.",
    },
    {
      title: "Comprehensive Customer Information Management: ",
      desc: "Provide agents with detailed customer data on-site, enabling them to log activities, create support tickets, and manage opportunities with ease.",
    },
  ],
  features3: [
    {
      title: "Work Hours and Travel Time Tracking: ",
      desc: "Log start and end times of the workday, calculate travel distances, and automate travel claim submissions for effortless reimbursement.",
    },
    {
      title: "Check-In and Check-Out at Visit Locations: ",
      desc: "Track agent availability and task completion at each scheduled location, ensuring accurate reporting and customer satisfaction.",
    },
    {
      title: "Automated Travel Expense Management: ",
      desc: "Simplify travel claims with real-time tracking of distance and work hours, making expense reimbursement quick and hassle-free.",
    },
  ],
  features4: [
    {
      title: "Data-Driven Insights with Advanced Dashboards: ",
      desc: "Analyze key performance metrics such as task completion rates, payment collections, and team KPIs through user-friendly dashboards.",
    },
    {
      title: "Customizable Reports for Field Operations: ",
      desc: "enerate detailed, customizable reports to support data-driven decision-making and operational improvements across all departments.",
    },
  ],
};
